/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Parents_DescriptionInputs */

const fr_guardian_parents_description = /** @type {(inputs: Guardian_Parents_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les parents peuvent inscrire cet enfant aux cours.`)
};

/**

* @param {Guardian_Parents_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_parents_description = /** @type {((inputs?: Guardian_Parents_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Parents_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_parents_description(inputs)
});